module.exports = __webpack_public_path__ + "img/report_pic3.81545d54.png";